import DefaultCatProfileIcon from 'assets/icons/default-cat-profile-icon.svg';
import DefaultDogProfileIcon from 'assets/icons/default-dog-profile-icon.svg';
import { BREED_IMAGE_MAP } from 'components/pet-profile/constants';
import { PetContextValues } from 'contexts/pet';
import Image from 'next/legacy/image';

interface PropTypes {
  selectedBreed?: string;
  size: number;
  petType: Exclude<PetContextValues, false>;
}

/**
 * Component that displays the pet profile image or a default icon if no breed is selected.
 * Used on the PetProfileCollectionSelector component.
 */
const ProfileImage: React.FC<PropTypes> = ({
  selectedBreed,
  size,
  petType,
}) => (
  <span
    data-test="pet-profile-image-container"
    className="shrink-0 overflow-hidden rounded-full"
    style={{ height: `${size}px` }}
  >
    {petType === 'dogs' && selectedBreed ? (
      <Image
        data-test="dog-breed-profile-image"
        src={BREED_IMAGE_MAP[selectedBreed]}
        alt={`Breed ${selectedBreed}`}
        width={size}
        height={size}
      />
    ) : petType === 'dogs' ? (
      <DefaultDogProfileIcon
        data-test="default-dog-profile-icon"
        style={{ width: `${size}px` }}
      />
    ) : (
      <DefaultCatProfileIcon
        data-test="default-cat-profile-icon"
        style={{ width: `${size}px` }}
      />
    )}
  </span>
);

export default ProfileImage;
